import { colors } from 'bench-style-constants';
import React from 'react';
import styled from 'styled-components';

const TruncatedContent = styled.div`
  overflow: hidden;
  padding: 0 4px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const FloatingContent = styled.div`
  background: ${colors.white};
  box-shadow: 0 0 1px 1px ${colors.dust}, 0 2px 3px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  display: none;
  left: 0;
  padding: 0 4px;
  position: absolute;
  right: 0;
  top: 0;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0 6px;
`;

const NoteLayout = styled.div`
  cursor: default;
  margin: 0 -4px;
  position: relative;
  text-align: left;

  &:hover {
    z-index: 2;
  }

  &:hover ${FloatingContent} {
    display: block;
  }
`;

interface FloatingExpandableTextProps {
  children: React.ReactNode;
}

/**
 * Takes some text and truncates it to a single line with an ellipsis at the end. When the cursor
 * is hovering over the text, it shows the full content with proper line breaks.
 */
const FloatingExpandableText: React.FC<FloatingExpandableTextProps> = ({ children }) => (
  <NoteLayout>
    <TruncatedContent>{children}</TruncatedContent>
    <FloatingContent>{children}</FloatingContent>
  </NoteLayout>
);

FloatingExpandableText.defaultProps = {
  children: null,
};

export default FloatingExpandableText;
